'use client'

import { clientPage } from '../../_lib/clientPage'

export default clientPage(() =>
  import('@/components/views/TeamView').then((m) => ({
    default: m.TeamView,
  }))
)
